import React, { createContext, useState, useEffect, useContext } from "react";
import { IntlProvider } from "react-intl";

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

const LandingLoader = () => (
  <div style={{
    position: 'fixed', inset: 0, background: '#021B2E',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999
  }}>
    <div style={{
      width: 36, height: 36,
      border: '3px solid rgba(14,165,233,0.2)',
      borderTopColor: '#0EA5E9',
      borderRadius: '50%',
      animation: 'spin 0.7s linear infinite'
    }} />
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

const modulesToLoad = [
  "landing-page/aboutPage",
  "landing-page/practicalityPage",
  "landing-page/interactivityPage",
  "landing-page/analysisPage",
  "landing-page/header",
  "landing-page/footer",
  "landing-page/heroSection",
  "landing-page/aboutSection",
  "landing-page/featuresSection",
  "landing-page/howItWorksSection",
  "landing-page/ctaSection",
  "landing-page/useCasesSection"
];

const LanguageProvider = ({ children }) => {
  const [locale, setLocale] = useState(
    localStorage.getItem("language") || "pt-br"
  );
  const [messages, setMessages] = useState({});
  const [ready, setReady] = useState(false);

  // Função auxiliar para carregar e mesclar todos os arquivos de tradução
  async function loadLocaleData(locale) {
    const promises = modulesToLoad.map(modulePath =>
      import(`../i18n/locales/${locale}/${modulePath}.json`)
    );

    const results = await Promise.allSettled(promises);
    const messages = results.reduce((acc, result) => {
      if (result.status === "fulfilled") {
        return { ...acc, ...result.value.default };
      }
      return acc;
    }, {});
    return messages;
  }

  useEffect(() => {
    setReady(false);
    const loadMessages = async () => {
      try {
        const loadedMessages = await loadLocaleData(locale);
        setMessages(loadedMessages || {});
      } catch (error) {
        console.error(`Could not load messages for locale: ${locale}`, error);
        if (locale !== "en-us") {
          setLocale("en-us");
        }
      } finally {
        setReady(true);
      }
    };
    loadMessages();
  }, [locale]);

  const changeLanguage = newLocale => {
    localStorage.setItem("language", newLocale);
    setLocale(newLocale);
  };

  return (
    <LanguageContext.Provider value={{ locale, changeLanguage }}>
      <IntlProvider locale={locale} messages={messages} defaultLocale="pt-br">
        {ready ? children : <LandingLoader />}
      </IntlProvider>
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;
